src/views/machine/admin/MachineRecord.vue<template>
	<div class="machine-record">
		<div class="el-search vue-top-padding radius">
			<div
				style="float: left; line-height: 32px; height: 32px; font-size: 15px;"
			></div>
			<div class="el-right">
				<el-form
					ref="machineRecord"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item prop="state" style="margin: 0 10px 0 0;">
						<el-select
							v-model="search.state"
							:no-data-text="$t('common.noData')"
							:no-match-text="$t('common.noData')"
							clearable
							:placeholder="$t('machineRecord.state')"
						>
							<el-option :label="$t('machineRecord.online')" :value="1">
							</el-option>
							<el-option :label="$t('machineRecord.unline')" :value="0">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="equipmentNo" style="margin: 0 10px 0 0;">
						<el-input
							v-model="search.equipmentNo"
							:placeholder="$t('machineRecord.pMachineNo')"
						></el-input>
					</el-form-item>
					<el-form-item prop="dateTime" style="margin: 0 10px 0 0;">
						<el-date-picker
							style="max-width: 320px;"
							v-model="dateTime"
							type="datetimerange"
							:picker-options="pickerOptions"
							range-separator="-"
							:start-placeholder="$t('searchOrder.start')"
							:end-placeholder="$t('searchOrder.end')"
							value-format="yyyy-MM-dd HH:mm:ss"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item style="margin: 0;">
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button
							@click="resetSearch('machineRecord')"
							icon="el-icon-refresh"
							>{{ $t("common.reset") }}</el-button
						>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="vue-padding">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="machineRecordList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="equipmentNo"
					:show-overflow-tooltip="true"
					:label="$t('machineRecord.equipmentNo')"
					:align="'center'"
					width="150px"
				></el-table-column>
				<el-table-column
					prop="state"
					:show-overflow-tooltip="true"
					:label="$t('machineRecord.state')"
					:align="'center'"
				>
					<template #default="scoped">
						{{
							scoped.row.state == 1
								? $t("machineRecord.online")
								: $t("machineRecord.unline")
						}}
					</template>
				</el-table-column>

				<el-table-column
					prop="createTime"
					:label="$t('machineRecord.createTime')"
					:align="'center'"
					width="170px"
				></el-table-column>
			</el-table>
			<el-pagination
				v-if="machineRecordList.length > 0"
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	name: "OfflineRecord",
	data() {
		return {
			dateTime: null,
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			search: {
				equipmentNo: "",
			},
			machineRecordList: [],
			loading: false,
		};
	},
	mounted() {
		this.currentChange();
	},
	methods: {
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.OffLineRecord.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.machineRecordList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},

		onSubmit() {
			if (this.dateTime) {
				this.search.startTime = this.dateTime[0];
				this.search.endTime = this.dateTime[1];
			} else {
				this.search.startTime = "";
				this.search.endTime = "";
			}
			this.currentChange();
		},

		resetSearch(formName) {
			this.dateTime = null;
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.currentChange();
		},
	},
};
</script>

<style scoped></style>
